import { Trash2 } from 'lucide-react';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import datas from "../../Assets/data.json";
import Generate from './Generate';
import NewPub from '../Pub/NewPub';
import env from 'react-dotenv';
import { Crypter } from '../../Functions/Security/Crypter';
import { queueHub } from '../../Services/signalr';
import { useAlert, Spin, DataTable, Badge, IconButton, RadioGroup, SearchInput } from '../ui';
import { DataTableColumn } from '../ui/DataTable';
import TableStatusBar from '../ui/TableStatusBar';
import PageHeader from '../ui/PageHeader';

const columns: DataTableColumn[] =
    [
        { field: 'CodeT', headerName: 'Code Ticket', width: 100 },
        { field: 'DateCreatee', headerName: 'Date création', width: 150 },
        { field: 'CodeU', headerName: 'Crée par', width: 150 },
        { field: 'CodeFiliale', headerName: 'Filiale', width: 150 },
        { field: 'CodeS', headerName: 'Service', width: 150 },
        {
            field: 'Statut', headerName: 'Statut', width: 100, renderCell: (record) => (
                <Badge color={record.value == 4 ? "blue" : record.value == 2 ? "green" : record.value == 3 ? "red" : record.value == 5 ? "amber" : "gray"}>
                    {record.value == 4 ? "Apellé" : record.value == 2 ? "Validé" : record.value == 3 ? "Rejeté" : record.value == 5 ? "Transféré" : "Nouveau"}
                </Badge>
            ),
        },
        { field: 'CodeOperateur', headerName: 'Opérationnel', width: 150 },
        { field: 'Number', headerName: 'Numéro Box', width: 150 },
        {
            field: 'Actions', headerName: 'Actions', width: 150, sortable: false,
            renderCell: (record) => (
                <div className="flex items-center gap-2">
                    <IconButton tooltip="Retirer de la file" color='danger' size={32}><Trash2 size={16} /></IconButton>
                </div>
            ),
        },
    ];

export default function GenerationTicket() {

    // USER TOKEN
    const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert();

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [data, setData] = useState([])

    const [dataTri, setDataTri] = useState<any>([])

    const [loading, selLoading] = useState(false)
    const [textRes, setTextRes] = useState("")

    const [filtre, setFiltre] = useState('a')
    // Ref pour que les handlers SignalR (enregistrés une fois) lisent le filtre courant
    const filtreRef = React.useRef(filtre)
    React.useEffect(() => { filtreRef.current = filtre }, [filtre])



    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        LoadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // SignalR /hubs/queue — la liste se rafraîchit sur chaque événement de file
    // (appel, validation, rejet, transfert, annulation, snapshot, maj générale).
    useEffect(() => {
        const getJwt = () => (authHeader() || '').replace(/^Bearer\s+/i, '')
        const scope = { codeAbonne: user.CodeAbonne, codeFiliale: user.CodeFiliale, codeS: user.CodeS }
        queueHub.acquire(getJwt, scope).catch(() => { })

        const events = ['FileUpdated', 'QueueSnapshot', 'TicketCalled', 'TicketValidated',
            'TicketRejected', 'TicketTransferred', 'TicketNoShow', 'TicketCancelled']
        const unsubs = events.map((ev) => queueHub.on(ev, () => LoadData()))

        return () => {
            unsubs.forEach((u) => u())
            queueHub.release()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function LoadData() {
        selLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.AllTickets + Crypter.encrypt(JSON.stringify({ "CodeAbonne": user.CodeAbonne, "CodeFiliale": user.CodeFiliale })),
            headers: {
                'Accept': 'text/plain',
                'Authorization': authHeader(),
            }
        };

        axios.request(config)
            .then((response: any) => {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    selLoading(false)
                    setData(res.Result)
                    // Re-applique le filtre actif (rafraîchissement SignalR inclus)
                    const dte = filtreRef.current === 'a' ? res.Result : res.Result.filter((el: any) => el.Statut == filtreRef.current)
                    setDataTri(dte)
                    setTextRes(dte.length + ' Resultat(s) obtenu')
                    //localStorage.setItem("tabGuichet", JSON.stringify(response.data.result.slice(0, 25)))
                }
                else {
                    selLoading(false)
                    setDataTri([])
                    //localStorage.setItem("tabGuichet", JSON.stringify([]))
                    setTextRes("")
                    alert.warning(res.Message)
                }
            })
            .catch((error: any) => {
                setTextRes("")
                alert.error('Error', error)
                selLoading(false)
                console.log(error);
            });
    }

    function tri(type: string) {

        var dte: any[] = []
        if (type == "a") {
            dte = data
        } else {
            data.map((el: any) => {
                if (el.Statut == type) {
                    dte.push(el)
                }
            })

        }
        setDataTri(dte)

        setTextRes(dte.length + " Resultat(s) obtenu")

    }

    //   setTimeout(() => {
    //     try{
    //         let loadQmGuichet = localStorage.getItem("loadQmGuichet")
    //         if(loadQmGuichet == "1"){
    //             LoadData()
    //             localStorage.removeItem("loadQmGuichet")
    //         }
    //     }catch(e){}
    //   }, 1);

    return (
        <Spin spinning={loading} >
            <PageHeader
                title="Gestion des tickets"
                subtitle="Générez et suivez les tickets de la file d'attente"
                actions={<Generate handleFunction={LoadData} />}
            />
            <>
                <RadioGroup
                    value={filtre}
                    onChange={(v) => { setFiltre(v); tri(v) }}
                    options={[
                        { value: 'a', label: 'Tous les tickets' },
                        { value: '1', label: 'Tickets non utilisés' },
                        { value: '2', label: 'Tickets validés' },
                        { value: '3', label: 'Tickets rejétés' },
                        { value: '5', label: 'Tickets transférés' },
                        { value: '4', label: 'Tickets appellés' },
                    ]}
                />
            </>

            <div className="eb-table-wrap mt-3">
                <SearchInput onSearch={LoadData} size='lg' className="mb-3" placeholder='Saisissez pour effectuer une recherche profonde' />
                <DataTable rows={dataTri} columns={columns} height={300} searchable />
            </div>
            <TableStatusBar count={dataTri.length} loading={loading} onRefresh={LoadData} />
        </Spin>
    );
}
